<template>
  <div class="shop-focus-card" :class="{ isBatch }">
    <div class="shop-card-header">
      <el-checkbox
        v-if="isBatch"
        v-model="goods.isSelected"
        class="shop-checkbox"
      ></el-checkbox>
      <img :src="goods.shopLogoUrl || defaultLogo" class="shop-logo" />
      <span class="shop-platform">中交云采</span>
      <span v-if="!isBatch" class="delete-btn" @click.stop="handleDelete(goods)"
        >删除</span
      >
    </div>
    <div class="shop-card-body" @click="goShopHome">
      <div class="shop-name">{{ goods.shopName }}</div>
    </div>
    <div v-if="!isBatch" class="shop-card-overlay" @click="goShopHome">
      <span class="delete-text" @click.stop="handleDelete(goods)">删除</span>
    </div>
  </div>
</template>
<script>
import defaultLogo from "@/assets/images/default.png";
export default {
  name: "shop-focus-card",
  props: {
    isBatch: {
      default: false,
      type: Boolean
    },
    goods: {
      default() {
        return {};
      },
      type: Object
    }
  },
  data() {
    return {
      defaultLogo
    };
  },
  methods: {
    goShopHome() {
      const VUE_APP_EMS_URL = this.$addUrlPerFix(process.env.VUE_APP_EMS_URL);
      window.open(`${VUE_APP_EMS_URL}?shopId=${this.goods.secretShopCode}`);
    },
    handleDelete(goods) {
      this.$emit("delete", goods);
    }
  }
};
</script>
<style lang="scss" scoped>
.shop-focus-card {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 80px;
  user-select: none;
  background: #ffffff;
  border: 1px solid #ececec;
  border-radius: 4px;
  overflow: hidden;
  transition: all 0.3s ease;

  &.isBatch {
    background: #f5f5f5;
    border-color: #d9d9d9;
  }

  .shop-card-header {
    display: flex;
    align-items: center;
    padding: 10px 12px 0;
    position: relative;

    .shop-checkbox {
      margin-right: 8px;
      /deep/ .el-checkbox__inner {
        width: 16px;
        height: 16px;
      }
      /deep/ .el-checkbox__inner::after {
        width: 4px;
        height: 8px;
        left: 4px;
      }
    }

    .shop-logo {
      width: 20px;
      height: 20px;
      object-fit: contain;
      margin-right: 6px;
    }

    .shop-platform {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #1a6fb5;
      line-height: 20px;
    }

    .delete-btn {
      position: absolute;
      right: 12px;
      top: 10px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #666666;
      cursor: pointer;
      &:hover {
        color: #ff142f;
      }
    }
  }

  .shop-card-body {
    padding: 8px 12px;
    cursor: pointer;

    .shop-name {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #333333;
      line-height: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .shop-card-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    cursor: pointer;

    .delete-text {
      position: absolute;
      top: 10px;
      right: 12px;
      color: white;
      font-size: 13px;
    }
  }
}

.shop-focus-card:hover .shop-card-overlay {
  opacity: 1;
  visibility: visible;
}

.shop-focus-card.isBatch .shop-card-overlay {
  display: none;
}
</style>
